export default __webpack_public_path__ + "static/media/care-cord.9bcef3c4.png";